import React from 'react';
import Spinner from './Spinner';

/**
 * Centered page-level loader (spinner + message). For full-page loading states
 * (MSIG, TopHolders, ProposalDetails, AccountDetail).
 */
const PageLoader = ({ message = 'Loading...', size = 32 }) => (
  <div className="flex flex-col items-center justify-center min-h-[40vh] text-gray-600 px-4">
    <Spinner size={size} className="mb-3" />
    {message && <p className="text-sm">{message}</p>}
  </div>
);

export default PageLoader;
